import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'miq-session-expiry-dialog',
  templateUrl: './session-expiry-dialog.component.html',
  styleUrls: ['./session-expiry-dialog.component.scss'],
  standalone: false,
})
export class SessionExpiryDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SessionExpiryDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public injectedData: any
  ) {}

  continue() {
    this.dialogRef.close();
  }
}
